import * as Yup from "yup";

export const leadClosureSchema = Yup.object().shape({
  gym_id: Yup.object()
    .shape({
      label: Yup.string().required("gym is required"),
      value: Yup.string().required("gym is required"),
    })
    .required("gym is required"),
});

export const expenseSchema = Yup.object().shape({
  user_id: Yup.object().required("Please select user"),
  role_type: Yup.object().required("role is required"),
  isActive: Yup.boolean().required(),
});

export const TvNotificationSchema = Yup.object().shape({
  // user_id: Yup.string().required("User is required"),
  // time_interval: Yup.string()
  //   .required("Time interval is required")
  //   .test(
  //     "not-zero",
  //     "Time interval cannot be 00:00:00",
  //     (value) => value !== "00:00:00"
  //   ),
  time_from: Yup.string()
    .required("Time from is required")
    .test(
      "not-zero",
      "Time from cannot be 00:00:00",
      (value) => value !== "00:00:00"
    ),
  time_to: Yup.string()
    .required("Time to is required")
    .test(
      "not-zero",
      "Time to cannot be 00:00:00",
      (value) => value !== "00:00:00"
    ),
  notification_role: Yup.string().required("Notification role is required"),
});

export const tvStakeholderSchema = Yup.object().shape({
  user_id: Yup.string().required("User is required"),
  tv_stakeholder_type: Yup.string().required("Stakeholder type is required"),
});

export const trainerSchema = Yup.object().shape({
  trainer_category_id: Yup.string().required("Trainer category is required"),
  gym_id: Yup.string().required("Gym is required"),
  //   location: Yup.string().required("location is required"),
  address1: Yup.string().nullable(true),
  address2: Yup.string().nullable(true),
  city: Yup.string().nullable(true),
  state: Yup.string().nullable(true),
  pin: Yup.string().required("pin is required"),
  trainer_exp_lvl: Yup.string().required(
    "Trainer Experience Level is required"
  ),
  trainer_lang: Yup.string().required("Trainer Language is required"),
  trainer_exp_pt: Yup.string().required(
    "Experience as Personal Trainer is required"
  ),
  trainer_exp_gt: Yup.string().required(
    "Experience as General Trainer is required"
  ),
  description: Yup.string().nullable(true).nullable(true),
  date_onboarding: Yup.string().required("Joining Date is required"),
  pan_card: Yup.mixed().nullable(true),
  aadhar_card: Yup.mixed().nullable(true),
  status: Yup.string().nullable(true),
  is_default: Yup.string().nullable(true),
  // experties: Yup.array().of(Yup.string()).required("Expertise is required"),
  trainer_expt: Yup.string()
    .test("is-valid-expertise", "Select at least one expertise", (value) => {
      return value && value.trim().length > 0; // Ensure it's not empty
    })
    .required("Trainer expertise is required"),
});

export const versionSchema = Yup.object().shape({
  app: Yup.string().required("App is required"),
  wtf_version: Yup.string().required("WTF version is required"),
  apple_version: Yup.string().required("Apple version is required"),
  google_version: Yup.string().required("Google version is required"),
  description: Yup.string()
    .required("Description is required")
    .test("not-empty", "Description is required", (value) => {
      return value && value.replace(/<[^>]*>/g, "").trim().length > 0;
    }),
  force_update: Yup.number().nullable().optional(),
});

export const gallerySchema = Yup.object().shape({
  gym_id: Yup.string().required("Gym is required"),
  category_id: Yup.string().required("Category is required"),
  status: Yup.string().required("Status is required"),
  image: Yup.array()
    .of(
      Yup.mixed().test("fileType", "Invalid file type", (value) => {
        if (!value) return false;
        const isImage = value.type.startsWith("image/");
        const isVideo = value.type.startsWith("video/");
        return isImage || isVideo;
      })
    )
    .min(1, "At least one file is required")
    .max(5, "You can upload a maximum of 5 files")
    .test("single-video", "Only one video is allowed", (files) => {
      const videoFiles = files.filter((file) => file.type.startsWith("video/"));
      return videoFiles.length <= 1;
    })
    .required("At least one image or video is required"),
});

export const wtfBenefitsSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  image: Yup.mixed()
    .test("fileType", "Only images are allowed", (value) => {
      if (typeof value === "string") {
        // If it's a string (URL), assume it's valid in edit mode
        return true;
      }
      // Otherwise, validate as a file
      return value && value.type && value.type.startsWith("image/");
    })
    .required("Image is required"),
  status: Yup.string().required("Status is required"),
});

export const NotificationSheduleSchema = Yup.object().shape({
  gym_id: Yup.string().required("Gym is required"),
  account_type: Yup.string().required("Account Type is required"),
  name: Yup.string().required("Name is required"),
  subscription_type: Yup.string().nullable(),
  type: Yup.string().required("Type is required"),
  data: Yup.array()
    .of(
      Yup.object().shape({
        date: Yup.string()
          .matches(/^\d{2}-\d{2}-\d{4}$/, "Invalid date format (DD-MM-YYYY)")
          .required("Date is required"),
        times: Yup.array()
          .of(
            Yup.object().shape({
              time: Yup.string()
                .matches(
                  /^([01]\d|2[0-3]):([0-5]\d)$/,
                  "Invalid time format (HH:mm)"
                )
                .required("Time is required"),
              title: Yup.string().required("Title is required"),
              message: Yup.string().required("Message is required"),
              image: Yup.string().url("Invalid image URL").nullable(),
              dynamic_link: Yup.string().url("Invalid URL").nullable(),
            })
          )
          .min(1, "At least one time entry is required")
          .required("Times are required"),
      })
    )
    .min(1, "At least one date entry is required")
    .required("Data is required"),
});

export const notifcationImmediateSchema = Yup.object().shape({
  gym_id: Yup.string().required("Gym is required"),
  name: Yup.string().required("Name is required"),
  title: Yup.string().required("Title is required"),
  account_type: Yup.string().required("Account type is required"),
  status: Yup.string().required("Status is required"),
  media: Yup.mixed().nullable(),
  subscription_type: Yup.string().nullable(),
  dynamic_link: Yup.string().url("Invalid URL").nullable(),
  type: Yup.string().required("Type is required"),
  message: Yup.string().required("Message is required"),
  date: Yup.string().required("Date is required"),
  time: Yup.string().required("Time is required"),
});

//default - status, date

export const earningTaskSchema = Yup.object().shape({
  value: Yup.number().required("Coin reward is required"),
  reference: Yup.string().required("Task name is required"),
});

export const ticketUserRoleSchema = Yup.object({
  selectedUser: Yup.object().required("User Required!"),
  selectedRole: Yup.object().required("Role Type Required!"),
  isActive: Yup.boolean(),
});

export const ticketValidationSchema = Yup.object().shape({
  gymName: Yup.object().required("Gym selection is required"),
  issueType: Yup.object().required("Issue type is required"),
  category: Yup.object().required("Category is required"),
  subcategory: Yup.object().required("Subcategory is required"),
  priority: Yup.object().required("Priority is required"),
  description: Yup.string()
    .min(10, "Description must be at least 10 characters")
    .max(250, "Description cannot exceed 250 characters")
    .required("Description is required"),
  mediaFiles: Yup.object()
    .shape({
      images: Yup.array(),
      videos: Yup.array(),
    })
    .test(
      "at-least-one-media",
      "At least one image or video is required as proof",
      (value) => {
        if (!value) return false;
        const hasImages = value.images && value.images.length > 0;
        const hasVideos = value.videos && value.videos.length > 0;
        return hasImages || hasVideos;
      }
    )
    .required("Media files are required"),
});
